<button mat-button [matMenuTriggerFor]="menu" gaEvent="specifications" gaCategory="menu_tracking">Specificatii</button>
<mat-menu #menu="matMenu">
  <a href="https://experttabla.ro/bilka/" mat-menu-item>Bilka</a>
  <a href="https://experttabla.ro/wetterbest/" mat-menu-item>Wetterbest</a>
</mat-menu>

